module.exports = __webpack_public_path__ + "static/media/picto-heart-blue.4dcb0172.svg";